import type { FuseSearchResult } from '@talos/kyoko';
import type { MarketSelectorCustomPresetItem } from '../../types';
import type { PresetRowEntry } from '../presetListModel';
import { PresetListRowHoverRoot } from '../styles';
import { AggregationPresetRow } from './AggregationPresetRow';

export function AggregationListItem({
  selection,
  searchResult,
  favorite,
  onFavoriteClicked,
  customPresetItemsByID,
  defaultAggregationId,
  onDefaultAggregationChange,
}: {
  selection: string | undefined;
  searchResult: FuseSearchResult<PresetRowEntry>;
  favorite: boolean;
  onFavoriteClicked: () => void;
  customPresetItemsByID: Map<string, MarketSelectorCustomPresetItem>;
  defaultAggregationId: string | undefined;
  onDefaultAggregationChange: (id: string | undefined) => void;
}) {
  const row = searchResult.item.item;
  const presetID = row.presetId;
  const isCustom = customPresetItemsByID.has(presetID);
  const isDefault = defaultAggregationId === presetID;
  const isDefaultPin = row.kind === 'aggregation' && row.placement === 'defaultPin';

  const rowTestId = isDefaultPin
    ? 'market-selector-default-aggregation-pinned-row'
    : !isCustom && isDefault
      ? 'market-selector-default-aggregation-row'
      : 'aggregation-list-item';

  return (
    <PresetListRowHoverRoot data-testid="market-selector-preset-row-hover-area">
      <AggregationPresetRow
        presetID={presetID}
        selection={selection}
        favorite={favorite}
        onFavoriteClicked={onFavoriteClicked}
        customPresetItemsByID={customPresetItemsByID}
        defaultAggregationId={defaultAggregationId}
        onDefaultAggregationChange={onDefaultAggregationChange}
        rowTestId={rowTestId}
        pinnedDefaultRow={isDefaultPin}
      />
    </PresetListRowHoverRoot>
  );
}
